import { IRootState } from '../../../../store'
import { ISessionResumeState } from './sessionResume.types'

export const getSessionResumeSelector = (state: IRootState): ISessionResumeState => state.sessionResume
